import { render, staticRenderFns } from "./ImageContentSplit.vue?vue&type=template&id=1dd66415&scoped=true&"
import script from "./ImageContentSplit.vue?vue&type=script&lang=js&"
export * from "./ImageContentSplit.vue?vue&type=script&lang=js&"
import style0 from "./ImageContentSplit.vue?vue&type=style&index=0&id=1dd66415&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd66415",
  null
  
)

export default component.exports